// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contact__line--no-data[data-v-478387ee] {\n  color: var(--v-primary-base);\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
